import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { parentUpdate, parentEdit } from '../../../../store/actions/menuActions'

const ParentEdit = () => {
  const [name, setname] = useState('')
  const [icon, seticon] = useState('')
  const [access, setaccess] = useState('')

  const dispatch = useDispatch()
  const history = useHistory()
  const id = localStorage.getItem('id_parent');

  const dataparentUpdate = useSelector(state => state.parentUpdate)
  const { validation } = dataparentUpdate

  const dataparentEdit = useSelector(state => state.parentEdit)
  const { parent } = dataparentEdit
  
  useEffect(() => {
    dispatch(parentEdit(id))
  }, [id])

    useEffect(() => {
          if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
      if (!userInfo.permission.includes("parent-edit")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
    }, []);
  
    const dataLogin = useSelector((state) => state.login);
    let { userInfo } = dataLogin;

  useMemo(() => {
    if (parent) {
      setname(parent.name)
      seticon(parent.icon)
      setaccess(parent.access)
    }
  }, [parent])

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(parentUpdate(name, icon, access, id, history))
  }

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Edit Parent</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>
            
            <div className="x_content overflow-auto">  
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group">
                  <label>Name</label>
                  <input type="text" 
                    className={ validation.length !== 0 && validation['name'] ? 'form-control parsley-error' : 'form-control' }
                    name="name" 
                    required 
                    onChange={(e) => setname(e.target.value)}
                    value={name}
                  />
                  
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['name']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <div className="form-group">
                  <label>Icon</label>
                  <input type="text" 
                    className={ validation.length !== 0 && validation['icon'] ? 'form-control parsley-error' : 'form-control' }
                    name="icon" required onChange={(e) => seticon(e.target.value)}  value={icon} />
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['icon']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <div className="form-group">
                  <label>Access</label>
                  <input type="text" 
                    className={ validation.length !== 0 && validation['name'] ? 'form-control parsley-error' : 'form-control' }
                    name="name" 
                    disabled
                    value={access}
                  />
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['access']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ParentEdit
